import { MODULE } from './../../helpers/security';

export default [
  {
    path: '/users',
    component: () => import('./views/User.vue'),
    meta: {
      requiresAuth: true,
      moduleCode: MODULE.USER
    },
    children: [
      {
        path: '',
        name: 'users',
        component: () => import('./views/UserList.vue'),
      },
      {
        path: ':id',
        name: 'users-view',
        component: () => import('./views/UserView.vue'),
      }
    ]
  }
];